import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProfileService from "services/profileService";

// Async thunk
export const fetchProfileStatus = createAsyncThunk(
    "profileStatus/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await ProfileService.getStatus();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Initial state
const initialState = {
    isProfileComplete: null,
    loading: false,
    error: null,
};

// Slice
const profileStatusSlice = createSlice({
    name: "profileStatus",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfileStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProfileStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.isProfileComplete = action.payload?.data?.isProfileComplete;
            })
            .addCase(fetchProfileStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default profileStatusSlice.reducer;
